import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";

import { useAuthUser } from "../../../hooks/useAuth";
import { hooks } from "../../../hooks";
import { APP_ROUTES } from "../../../constants/app_routes";

const AuthLayout = (props: any) => {
  const navigate = hooks.useNavigate();
  const { isAuthenticated, isLoading } = useAuthUser();
  //   const { asPath } = useRouter();
  //   const queryParams = asPath.split("?")[1];

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      navigate(APP_ROUTES.AUTH);
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (!isAuthenticated || isLoading) return <CircularProgress />;

  return <>{props.children}</>;
};
export default AuthLayout;
